export const NoteTypes = {
    'Action Item': 'actionItem',
    'Business Case': 'businessCase',
    'Discussion Point': 'discussionPoint',
    Question: 'question',
    Recommendation: 'recommendation',
    Security: 'security'
};

export const NoteTypesValues = Object.values(NoteTypes);
export const NoteTypesKeys = Object.keys(NoteTypes);

export const NoteTypesReversed = {
    actionItem: 'Action Item',
    businessCase: 'Business Case',
    discussionPoint: 'Discussion Point',
    question: 'Question',
    recommendation: 'Recommendation',
    security: 'Security'
};
